import { AxiosResponse } from 'axios';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';
import {
    IPortfolioManagerDetails,
    Portfolio,
} from './models/portfolio.service';

/**
 * Class responsible for manage the API calls and data request of the App
 */
export class PortfolioService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };
    /**
     * Instantiates a new ClientService
     */
    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    public async search(
        dealerId: string,
        searchType: string,
        searchValue: string | number,
        accountStatus: string,
    ): Promise<AxiosResponse<Portfolio[]>> {
        const url = `${this.dealerPortalUrlStructure}/searchPortfolio`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );
        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                dealerId,
                searchType,
                searchValue,
                accountStatus,
                jwtToken: permissionsToken,
            },
        };
        return this.client.sendRequest(request);
    }
    public async specialPrograms(
        dealerId: string,
        country: string,
        brand: string,
    ): Promise<AxiosResponse<String[]>> {
        const url = `${this.dealerPortalUrlStructure}/specialPrograms`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );
        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                dealerId,
                country,
                brand,
                jwtToken: permissionsToken,
            },
        };
        return this.client.sendRequest(request);
    }

    /**
     * Service to get portfolio manager details
     * @param dealerId
     * @param accountNumber
     * @param country
     */
    public async getPortfolioManagerDetails(
        dealerId: string,
        accountNumber: string,
        country: string,
    ): Promise<AxiosResponse<IPortfolioManagerDetails>> {
        const url = `${this.dealerPortalUrlStructure}/getPortfolioManagerDetails`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );
        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                dealerId,
                accountNumber,
                country,
                jwtToken: permissionsToken,
            },
        };
        return this.client.sendRequest(request);
    }

    public abort() {
        this.client.controller.abort();
    }
}
